export const credentialConnectionStatusSections = [
  { id: 'connected', label: 'Connected' },
  { id: 'pending', label: 'Pending' },
  { id: 'needsAttention', label: 'Needs attention' },
  { id: 'unsupported', label: 'Unsupported' }
];

const credentialConnectionStatusSectionById = Object.fromEntries(
  credentialConnectionStatusSections.map((section) => {
    return [section.id, section];
  })
);

export const credentialStatus = {
  valid: {
    label: 'Valid',
    connectionLabel: 'Connected',
    connectionSectionId: 'connected',
    tone: 'success',
    description: 'The credential is active and ready for use.',
    color: '#5cb15c',
    textColor: '#29925F',
    backgroundColor: '#EEF6F2'
  },
  expired: {
    label: 'Expired',
    connectionLabel: 'Expired',
    connectionSectionId: 'needsAttention',
    tone: 'danger',
    description: 'The credential has passed its expiration date and cannot be used.',
    color: '#d48b8b',
    textColor: '#F04438',
    backgroundColor: '#FEEFEE'
  },
  revoked: {
    label: 'Revoked',
    connectionLabel: 'Revoked',
    connectionSectionId: 'needsAttention',
    tone: 'danger',
    description: 'The credential has been manually revoked and is no longer valid.',
    color: '#d48b8b',
    textColor: '#F04438',
    backgroundColor: '#FEEFEE'
  },
  invalid: {
    label: 'Invalid',
    connectionLabel: 'Invalid',
    connectionSectionId: 'needsAttention',
    tone: 'danger',
    description: 'The credential is not valid, possibly due to incorrect data or format.',
    color: '#d48b8b',
    textColor: '#F04438',
    backgroundColor: '#FEEFEE'
  },
  incomplete: {
    label: 'Incomplete',
    connectionLabel: 'Incomplete',
    connectionSectionId: 'needsAttention',
    tone: 'warning',
    description: 'The credential setup is incomplete and requires additional information.',
    color: '#dbdbdb',
    textColor: '#697586',
    backgroundColor: '#F8F8F8'
  },
  unsupported: {
    label: 'Unsupported',
    connectionLabel: 'Unsupported',
    connectionSectionId: 'unsupported',
    tone: 'warning',
    description: 'The App does not yet support credential testing.',
    color: '#dbdbdb',
    textColor: '#697586',
    backgroundColor: '#F8F8F8'
  },
  unknown: {
    label: 'Untested',
    connectionLabel: 'Pending',
    connectionSectionId: 'pending',
    tone: 'neutral',
    description: 'The connection has not been tested yet or its validity is unknown.',
    color: '#dbdbdb',
    textColor: '#697586',
    backgroundColor: '#F8F8F8'
  }
};

export const getCredentialConnectionStatusPresentation = (status) => {
  const statusKey = status || 'unknown';
  const statusSchema = credentialStatus[statusKey];

  if (!statusSchema) {
    throw new Error(`Unsupported credential status "${statusKey}". Expected one of: ${Object.keys(credentialStatus).join(', ')}`);
  }

  const section = credentialConnectionStatusSectionById[statusSchema.connectionSectionId];

  if (!section) {
    throw new Error(`Credential status "${statusKey}" references unsupported connection section "${statusSchema.connectionSectionId}". Expected one of: ${credentialConnectionStatusSections.map((item) => item.id).join(', ')}`);
  }

  return {
    label: statusSchema.connectionLabel,
    section,
    tone: statusSchema.tone
  };
};
